import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { excuses, fullSpaces, realQuestions } from '../data/content';
import { Eyebrow, SectionTitle } from './ui/Section';
export function Pain() {
  return <section className="bg-blue-950 px-4 py-12 md:py-16" data-id="element-305" data-mp="1j0wrvhbfinwr">
      <div className="mx-auto max-w-4xl" data-id="element-306" data-mp="1j3j1rnlslfi5">
        <Eyebrow danger onDark data-id="element-307" data-mp="1e3ek3u95eeqc">
          😤 The Real Problem
        </Eyebrow>
        <SectionTitle onDark data-id="element-308" data-mp="1a1jhmmfhdvaz">
          You pick something up to declutter… and immediately find a reason to keep it.
        </SectionTitle>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-309" data-mp="158qe21vr0t0h">
          {excuses.map(excuse => <li key={excuse} className="rounded-xl border border-white/15 bg-white/5 p-4 text-center text-base font-black text-amber-400 md:text-lg" data-id="element-310" data-mp="10bq6fmj93i79">
              {excuse}
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-2xl space-y-1 text-center text-base font-semibold text-slate-200 md:text-lg" data-id="element-311" data-mp="mbp7wdqgkmuy">
          <p data-id="element-312" data-mp="1yw8adi7kakx6">And the item goes right back where it was.</p>
          <p data-id="element-313" data-mp="23nzqszx07a9l">Then the same thing happens with the next one.</p>
          <p data-id="element-314" data-mp="23pkk6m7l0n5v">And the next one.</p>
          <p className="pt-3 font-bold text-white" data-id="element-315" data-mp="23pswoczslqgj">Until…</p>
          {fullSpaces.map(line => <p key={line} className="font-black text-white" data-id="element-316" data-mp="1ty6f7ywv2v5c">
              {line}
            </p>)}
          <p className="pt-3" data-id="element-317" data-mp="2ho0s2gh6kjpl">
            And even the things you already chose to donate are still sitting inside your home.
          </p>
        </div>

        <div className="mt-10 rounded-2xl border-2 border-amber-400 bg-white p-6 md:p-8" data-id="element-318" data-mp="2mmc48xuy76az">
          <p className="text-center text-sm font-bold text-slate-600 md:text-base" data-id="element-319" data-mp="28mjeb4r8wu42">
            The problem is not always finding things you could remove.
          </p>
          <p className="mt-2 text-center text-xl font-black uppercase leading-tight text-blue-950 md:text-3xl" data-id="element-320" data-mp="x7o1loc5t2q5">
            The difficult part is deciding what to do with them.
          </p>
          <p className="mx-auto mt-5 max-w-2xl text-center text-sm font-semibold leading-relaxed text-slate-600 md:text-base" data-id="element-321" data-mp="33wpq9k5nqdrp">
            You may already know your home feels crowded. What you need is a practical way to
            answer questions like:
          </p>
          <ul className="mx-auto mt-5 grid max-w-3xl gap-2 sm:grid-cols-2" data-id="element-322" data-mp="2u40fkrhxl3xf">
            {realQuestions.map(question => <li key={question} className="flex items-start gap-2 rounded-lg bg-slate-50 px-3 py-2.5 text-sm font-bold text-blue-950" data-id="element-323" data-mp="2l67zhl4dxs8z">
                <HelpCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-yellow-700" aria-hidden="true" data-id="element-324" data-mp="2b7itaplupw8k" />
                {question}
              </li>)}
          </ul>
          <div className="mt-7 text-center" data-id="element-325" data-mp="26ain8ep04thg">
            <p className="text-sm font-semibold text-slate-600 md:text-base" data-id="element-326" data-mp="9ge2twvnn1pt">
              You do not need another generic decluttering checklist.
            </p>
            <p className="mt-1 text-xl font-black uppercase text-blue-950 md:text-2xl" data-id="element-327" data-mp="4f8ai05wpggt">
              You need a <span className="rounded bg-amber-300 px-1.5" data-id="element-328" data-mp="cw8soph0k1wo">decision system.</span>
            </p>
            <p className="mx-auto mt-4 max-w-2xl text-sm font-semibold leading-relaxed text-slate-600 md:text-base" data-id="element-329" data-mp="gxalangfdfpo">
              CLEAR THE CLUTTER™ gives you that system: choose the category, review the item,
              answer the questions, make the decision, and assign the next action.
            </p>
          </div>
        </div>
      </div>
    </section>;
}